import { ownedAssetPages } from './ownedAssetPages';

export default {
  title: 'Property and business assets',
  pages: ownedAssetPages,
};
